import { I18n } from "@/i18n";
import environment from "@/modules/environment";

type PushOptions = { query?: Record<string, string>; locale?: boolean };

export class Router {
  static url: URL;
  private static isLoaded = false;

  static init = (url?: string) => {
    if (environment.isServer) this.url = new URL(url!);
    else this.url = new URL(window.location.href);
    this.isLoaded = true;
  };

  static push = (href: string, options: PushOptions = { locale: true }) => {
    if (options.locale === undefined) options.locale = true;
    const { query, locale } = options;

    const _href = `${href}${queryToString(query)}`;
    const link = locale ? `/${I18n.locale}${_href === "/" ? "" : _href}` : href;
    window.location.href = link;
  };

  static getPathname = () => {
    if (!this.isLoaded && !environment.isServer) this.init();
    return this.url.pathname.split(`/${I18n.locale}`)[1];
  };
  //modify or add existing query parameters
  static updateQuery = (newQuery: Record<string, string>) => {
    const url = new URL(window.location.href);
    Object.entries(newQuery).forEach(([key, value]) => {
      if (value) url.searchParams.set(key, value);
      else url.searchParams.delete(key);
    });
    window.history.pushState({}, "", url.toString());
  };

  static clearQuery = () => {
    window.history.pushState({}, "", new URL(window.location.href));
  };

  static getQuery = () => {
    if (!this.isLoaded && !environment.isServer) this.init();
    const urlSearchParams = new URLSearchParams(this.url.search);
    return Object.fromEntries(urlSearchParams.entries()) as Record<string, string>;
  };

  static reload = () => {
    window.location.reload();
  };
}

export function useRouter() {
  return {
    pathname: Router.getPathname(),
    query: Router.getQuery(),
    push: Router.push,
    reload: Router.reload,
    updateQuery: Router.updateQuery,
    clearQuery: Router.clearQuery
  };
}

export function queryToString(query?: Record<string, string>) {
  if (!query) return "";
  const _query = new URLSearchParams(query).toString();
  return _query ? `?${_query}` : "";
}
